import type { PropsWithChildren } from 'react';
import type React from 'react';

import { Box, Checkbox, FormField, FormHelp, Label, LabeledControl } from '@zillow/constellation-10';

type Props = {
  beforeCheckboxContent?: React.ReactNode;
  afterCheckboxContent?: React.ReactNode;
  label: string;
  footer?: string;
  checkboxLabel: string;
  isChecked: boolean;
  onClick: () => void;
};

export default function Disclaimer({
  label,
  footer,
  checkboxLabel,
  isChecked,
  onClick,
  beforeCheckboxContent,
  afterCheckboxContent,
}: PropsWithChildren<Props>) {
  // The reason we're providing a key is we're using it to, in effect, force the constellation Checkbox to be a
  // controlled component.  The reason why we do this is because the initial checked state is sometimes dependent on
  // an API response. In these cases, the "defaultChecked" prop can flip from (false or undefined) to true and
  // wouldn't be reflected in the original Constellation Checkbox
  const key = (isChecked || false).toString();

  return (
    <Box
      data-testid="disclaimer-wrapper"
      css={{
        background: 'bg.accent.blue.soft',
        padding: 'loose',
        borderRadius: 'tight',
      }}
    >
      {beforeCheckboxContent}
      <FormField
        data-testid="disclaimer-form-field"
        required
        key={key}
        label={label && <Label>{label}</Label>}
        control={
          <LabeledControl
            onClick={onClick}
            label={<Label>{checkboxLabel}</Label>}
            control={<Checkbox defaultChecked={isChecked} />}
          />
        }
        description={footer && <FormHelp>{footer}</FormHelp>}
      />
      {afterCheckboxContent}
    </Box>
  );
}
